var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandCoinsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 26H2.5C2.23478 26 1.98043 25.8946 1.79289 25.7071C1.60536 25.5196 1.5 25.2652 1.5 25V20C1.5 19.7348 1.60536 19.4804 1.79289 19.2929C1.98043 19.1054 2.23478 19 2.5 19H6",
    stroke: "#687099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5C27.433 13.5 29 11.933 29 10C29 8.067 27.433 6.5 25.5 6.5C23.567 6.5 22 8.067 22 10C22 11.933 23.567 13.5 25.5 13.5Z",
    stroke: "#687099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20H18L26.375 18.0737C26.6829 17.9894 27.0061 17.9771 27.3195 18.038C27.6329 18.0988 27.9281 18.2312 28.182 18.4246C28.436 18.6181 28.6419 18.8676 28.7838 19.1536C28.9256 19.4396 28.9996 19.7545 29 20.0737C29.0002 20.4592 28.8929 20.8371 28.6902 21.165C28.4875 21.4929 28.1974 21.7578 27.8525 21.93L23 24L15 26H6V19L9.125 15.875C9.40432 15.5966 9.73577 15.3761 10.1004 15.226C10.465 15.0758 10.8557 14.999 11.25 15H17.5C18.163 15 18.7989 15.2634 19.2678 15.7322C19.7366 16.2011 20 16.837 20 17.5C20 18.163 19.7366 18.7989 19.2678 19.2678C18.7989 19.7366 18.163 20 17.5 20H14Z",
    stroke: "#687099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0573 10.635C21.4002 10.9614 20.657 11.073 19.9329 10.954C19.2088 10.835 18.5405 10.4914 18.0223 9.97188C17.5041 9.45232 17.1624 8.78304 17.0453 8.05865C16.9283 7.33426 17.0418 6.5914 17.37 5.93508C17.6982 5.27876 18.2243 4.74218 18.874 4.40119C19.5238 4.06019 20.2643 3.93204 20.9908 4.03484C21.7174 4.13764 22.3932 4.46619 22.9229 4.97406C23.4525 5.48192 23.8091 6.1434 23.9423 6.865",
    stroke: "#687099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoinsInactive);
export default __webpack_public_path__ + "static/media/HandCoinsInactive.51549e154bbd4ad54f99d2c665d8e93c.svg";
export { ForwardRef as ReactComponent };